import {NotificationDetails} from '../types/NotificationDetails';

export const SET_NOTIFICATION_DETAILS = 'SET_NOTIFICATION_DETAILS';
export const CLEAR_NOTIFICATIONS ='CLEAR_NOTIFICATIONS';


export function setNotificationDetails(value: NotificationDetails) {
    return {
        type: SET_NOTIFICATION_DETAILS,
        notificationDetails: value,
    };
}

export function clearNotifications(){
    return {
        type: CLEAR_NOTIFICATIONS
    }
}

